/// <reference path="../walkinManager.module.ts" />
/// <reference path="../../../components/models/meevo.model.custom.ts" />
/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.WalkinManager.AddToWaitlist {
    import Client = Meevo.Model.Client;
    import Employee = Meevo.Model.Employee;
    import EmployeeGenderSearchEnum = Meevo.Model.EmployeeGenderSearchEnum;
    import EmployeeSearchView = Meevo.Model.EmployeeSearchView;
    import IWalkinAppointmentSave = Meevo.Model.IWalkinAppointmentSave;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import ServiceCategory = Meevo.Model.ServiceCategory;
    import WalkInStatusEnum = Meevo.Model.WalkInStatusEnum;
    import IService = Meevo.Plugins.WalkinManager.AddToWaitlist.IService;
    import IServiceOpening = Meevo.Plugins.WalkinManager.AddToWaitlist.IServiceOpening;
    import WalkInWizardTypeEnum = Meevo.Plugins.WalkinManager.WalkInWizardTypeEnum;
    import BusinessInfoDataService = Meevo.Components.Common.BusinessInfoDataService;

    interface ICurrentPane {
        index: number;
        id: string;
    }

    interface IPaneForms {
        clientForm: ng.IFormController;
    }

    class WalkinManagerModalController {
        static $inject = [
            '$scope',
            '$q',
            'item',
            'windowType',
            '$mdDialog',
            'meevo.components.common.DataService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.SecurityService',
            'meevo.AppSettings',
            'meevo.components.modal.ModalService',
            'meevo.plugins.walkinManager.addToWaitlist.employeeListService',
            'meevo.plugins.walkinManager.addToWaitlist.serviceCategoryListService',
            'meevo.plugins.walkinManager.addToWaitlist.ScanForOpeningsService',
            'meevo.components.tracking.TrackingService',
            'meevo.plugins.walkinManager.WalkInSettingsService',
            'restServer'
        ];
        private securityKeys = Meevo.Components.Common.SecurityKeys;
        private stateFactory: Object;
        private initialLoad: boolean;
        public currentPane: ICurrentPane;
        public item: any;
        public accordion: any;
        public newClientForm: any;
        public editClientForm: any;
        public newClientFormVisible: Boolean;
        public newClientData: Client;
        public editClientData: Client;
        public selectedClient: Client;
        protected mdDialog: ng.material.IDialogService;
        public clientList: IClientList;
        public specificEmployeeVisible: Boolean;
        public serviceOpening: IServiceOpening;
        public walkInWizardType: any;
        public securityAdjustPriority: Boolean;
        public wasSMSEnabled: Boolean;
        public paneForms: IPaneForms;
        public employeeNickName: string;
        public phoneNumberAccess: SecurityAccessEnum;
        private suppressWarnings: boolean = false;
        public hideAnyGenderOptions: boolean = false;
        public clientEntryType: number = 0;
        public newClientEmailRequired = false;
        public newClientPhoneRequired = false;


        get currentService(): IWLSelectedService {
            return {
                service: this.serviceCategoryListService.currentService,
                addOns: this.serviceCategoryListService.currentAddOns,
                employeePreference: this.employeeListService.currentEmployeePreference,
                employee: this.employeeListService.currentEmployee,
            };
        }

        get employeeGenderSearchEnum(): typeof EmployeeGenderSearchEnum {
            return EmployeeGenderSearchEnum;
        }

        get employeeTabNotCompleted(): boolean {
            return this.currentService.employeePreference === null
                || (this.currentService.employeePreference === EmployeeGenderSearchEnum.SpecificEmployee
                    && !this.currentService.employee);
        }

        get securityAccessEnum(): typeof SecurityAccessEnum {
            return SecurityAccessEnum;
        }

        get isEdit(): boolean {
            return this.windowType === WalkInWizardTypeEnum.Edit;
        }

        get disabledAddButton(): boolean {
            return this.currentService.employeePreference === null
                || (this.employeeListService.currentEmployeePreference === EmployeeGenderSearchEnum.SpecificEmployee && !this.employeeListService.currentEmployee)
        }

        constructor(
            protected $scope: ng.IScope,
            protected $q: ng.IQService,
            item: any,
            protected windowType: WalkInWizardTypeEnum,
            protected $mdDialog: ng.material.IDialogService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected employeeListService: Meevo.Plugins.WalkinManager.AddToWaitlist.IEmployeeList,
            protected serviceCategoryListService: Meevo.Plugins.WalkinManager.AddToWaitlist.IServiceCategoryList,
            protected scanForOpeningsService: Meevo.Plugins.WalkinManager.AddToWaitlist.IScanForOpeningsService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected settingsService: Meevo.Plugins.WalkinManager.IWalkInSettingsService,
            protected restServer: any
        ) {
            this.mdDialog = $mdDialog;
            this.walkInWizardType = WalkInWizardTypeEnum;
            this.item = item || {
                isSMSEnabled: false,
                waitInWaitingArea: false,
                moveToTop: false,
                note: '',
                id: null
            };

            this.wasSMSEnabled = this.item.isSMSEnabled;

            this.currentPane = {
                index: 0,
                id: 'client-pane'
            };

            this.accordion = {};
            this.clientList = new ClientList(busyService, dataService, $q);


            console.log('hi3')


            this.employeeListService.searchCriteria = {
                eligibleForWalkinManager: true,
                view: EmployeeSearchView.WithEmployeeServicePricing,
                fetchEmployeePicture: true
            };

            this.stateFactory = {
                'client-pane': () => {},
                'service-pane': this.getServiceCategoryList.bind(this),
                'employee-pane': () => { angular.element('meevo-type-ahead[name="employee"]')[0].focus(); },
                'summary-pane': () => {}
            };

            this.addWatchers();

            this.securityService.checkSecurityKey(this.securityKeys.APPOINTMENTS_WALKINMANAGER_WAITLIST_ACTION_ADJUSTPRIORITY)
                .then((securityCode: SecurityAccessEnum) => {
                    this.securityAdjustPriority = securityCode === SecurityAccessEnum.Grant;
                });

            this.securityService.checkSecurityKey(this.securityKeys.DATA_CLIENT_FIELDGROUP_PHONENUMBERS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then((securityCode: SecurityAccessEnum) => {
                    this.phoneNumberAccess = securityCode;
                });

            if (windowType === WalkInWizardTypeEnum.Edit) {
                busyService.start();
                this.preloadData();
            }

            this.settingsService.fetchSettings()
                .then(() => {
                    this.hideAnyGenderOptions = this.settingsService.settings.hideAnyGenderOptions;
                });
        }

        /**
         * Add angular watchers on class init
         */
        addWatchers(): void {
            this.$scope.$watch(() => this.serviceCategoryListService.currentService, (newVal, oldVal) => {
                if (newVal && newVal !== oldVal && !this.initialLoad) {
                    this.employeeListService.searchCriteria.serviceId = newVal.id;
                }
            });

            this.$scope.$watch(() => this.item.moveToTop, (newVal, oldVal) => {
                if (newVal === true && newVal !== oldVal && !this.initialLoad) {
                    if (this.windowType === WalkInWizardTypeEnum.Edit) {
                        this.triggerMoveToTop();
                    }
                }
            });
        }

        /**
         * Start appointment editing from the very beginning
         * */
        startOver(): void {
            this.modalService.alert('ERROR_APPOINTMENT_MERGE_CONFLICT')
                .then(() => {
                    this.busyService.start();
                    this.dataService.getItem('walkinAppointment', this.item.id)
                        .then((response) => {
                            this.item = response;
                            this.accordion.expand('client-pane');
                            this.preloadData();
                        })
                        .finally(() => this.busyService.stop());
                });
        }

        /**
         * Preload appointment data before show edit window
         * */
        preloadData(): void {
            this.initialLoad = true;
            this.setEmployeeNickName();
            this.$q.all([
                this.clientList.getClientById(this.item.clientId),
                this.serviceCategoryListService.getServiceById(this.item.serviceId),
                this.employeeListService.getEmployeeById(this.item.employeeId)
            ])
                .then(() => {
                    this.item.selectedClient = this.clientList.currentClient;
                    this.editClientData = this.clientList.currentClient;
                    setTimeout(() => {
                        this.initialLoad = false;
                    }, 1000);
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        openServiceModal() {

            const options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/walkinManager/addToWaitlist/selectedServiceModal.html',
                controller: 'meevo.plugins.walkinManager.addToWaitlist.WalkinManagerSelectedServicesModalController',
                bindToController: true,
                locals: {
                    selectedService: this
                },
                controllerAs: 'vm',
                multiple: true
            };
            this.modalService.showCustom(options)
        }

        setEmployeeNickName() {
            WalkinAppointmentService.setEmployeePreferenceName(this.item);
            this.employeeNickName = this.item.parsedEmployeePreference === 'Specific Service Provider'
                ? this.item.employeeNickName
                : this.item.parsedEmployeePreference + ' Employee';
        }

        /**
         * Toggle new client form visibility.
         * In case of empty new client model - get it from server and then show form
         * */
        toggleNewClient(): void {
            if (this.newClientFormVisible) {
                this.newClientFormVisible = false;
                if (this.windowType === WalkInWizardTypeEnum.Edit) {
                    this.preloadData();
                }
            } else {
                if (typeof this.clientList.newClientTemplate === 'undefined') {
                    this.clientList.fetchClientTemplate()
                        .then((clientInfo: Client) => {
                            this.resetNewClient();
                            this.focusClientNameInput();
                        });
                } else {
                    if (this.windowType === WalkInWizardTypeEnum.Edit) {
                        this.resetNewClient();
                    }
                    this.focusClientNameInput();
                }
                this.item.selectedClient = undefined;
            }
        }

        /**
         * Reset new client data object to defaults on start and after adding client
         * */
        resetNewClient(): void {
            this.newClientFormVisible = false;
            this.newClientData = angular.copy(this.clientList.newClientTemplate);
        }

        /**
         * Send new client create request.
         * Select this client, and reset new client data object to defaults.
         * */
        createClient(): ng.IPromise<any> {
            this.busyService.start();

            return this.clientList.createClient(this.newClientData)
                .then(() => {
                    this.item.selectedClient = this.clientList.currentClient;
                    this.resetNewClient();
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * Handle back button click
         * */
        goBack() {
            let newIndex = this.currentPane['index'] - 1;

            if (this.currentPane['index'] === 1) { // go from service tab
                this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WalkInManagerModal, Model.VerbEnum.BackFromServicesClicked, null, this.item.id));

                if (this.windowType === WalkInWizardTypeEnum.Edit) {
                    this.clientList.getClientById(this.item.clientId)
                        .then((data: Client) => {
                            this.editClientData = this.clientList.currentClient;
                            this.item.entityVersion = data.entityVersion;
                        });
                }
                if (this.serviceCategoryListService.currentCategory) {
                    this.setCurrentCategory(null);
                } else {
                    this.accordion.toggle(newIndex);
                }
            } else if (this.currentPane['index'] === 2) { // go from employee tab
                this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WalkInManagerModal, Model.VerbEnum.BackFromEmployeesClicked, null, this.item.id));

                if (this.specificEmployeeVisible) {
                    this.specificEmployeeVisible = false;
                } else {
                    this.accordion.toggle(newIndex);
                }
            } else if (this.currentPane['index'] === 3) { // go from summary tab
                this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WalkInManagerModal, Model.VerbEnum.BackFromSummaryClicked, null, this.item.id));

                this.accordion.toggle(newIndex);
            }
        }

        /**
         * Handle continue button click
         * */
        goForward(): void {
            let newIndex = this.currentPane['index'] + 1;

            if (this.currentPane['index'] === 0) { // go from client tab
                this.goForwardFromClients(newIndex);
            } else if (this.currentPane['index'] === 1) { // go from service tab
                this.goForwardFromServices(newIndex);
            } else if (this.currentPane['index'] === 2) { // go from employee tab
                this.goForwardFromEmployees(newIndex);
            }
        }

        /**
         * Navigate forward from clients to services tab
         * @param {number} newIndex - new accordion tab index
         * */
        goForwardFromClients(newIndex: number): void {
            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WalkInManagerModal, Model.VerbEnum.ContinueFromClientsClicked, null, this.item.appointmentId));

            if (this.newClientFormVisible) {
                if (this.newClientForm.$valid) {
                    this.createClient()
                        .then(() => { // after resolve -> toggle
                            this.accordion.toggle(newIndex);
                        });
                }
            } else {
                this.dataService.getListPaged(this.appSettings.API_ENDPOINTS.walkinAppointment, {
                    criteria: {
                        clientId: this.item.selectedClient ? this.item.selectedClient.id : null
                    }
                })
                    .then((data: IWalkinAppointmentResponse | any) => {
                        let filteredItems = data.items
                            ? _.filter(data.items, (item: IWalkinAppointment) => {
                                return item.id !== this.item.id &&
                                    item.appointmentId !== this.item.appointmentId &&
                                    item.appointmentServiceFinalState !== Meevo.Model.AppointFinalStateEnum.Cancelled &&
                                    item.appointmentServiceFinalState !== Meevo.Model.AppointFinalStateEnum.CheckedOut;
                            })
                            : [];
                        if (filteredItems.length > 0) {
                            var message = 'Client already registered an appointment for today';
                            this.modalService
                                .alert(message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate, true)
                                .then(() => {
                                    return;
                                });
                        } else {
                            //if (this.newClientFormVisible) { // adding new client
                            //    if (this.newClientForm.$valid) {
                            //        this.createClient()
                            //            .then(() => { // after resolve -> toggle
                            //                this.accordion.toggle(newIndex);
                            //            });
                            //    }
                            //} else if (this.windowType === WalkInWizardTypeEnum.Edit) {
                            if (this.windowType === WalkInWizardTypeEnum.Edit) {
                                if (this.editClientForm.$dirty && this.editClientForm.$valid) { // update existing client
                                    this.clientList.updateClient(this.editClientData)
                                        .then(() => {
                                            this.item.selectedClient = this.clientList.currentClient;
                                            this.accordion.toggle(newIndex);
                                        })
                                } else {
                                    this.item.selectedClient = this.editClientData; // client is not changed. go forward
                                    this.accordion.toggle(newIndex);
                                }
                            } else {
                                if (Boolean(this.item.selectedClient)) { // if client was selected
                                    this.accordion.toggle(newIndex);
                                }
                            }
                        }
                    });
            }
        }

        /**
         * Navigate forward from services to employees tab
         * @param {number} newIndex - new accordion tab index
         * */
        goForwardFromServices(newIndex: number): void {
            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WalkInManagerModal, Model.VerbEnum.ContinueFromServicesClicked, null, this.item.appointmentId));

            if (this.currentService.service) {
                if (this.currentService.employee) { // if service changed - check if valid employee
                    this.scan()
                        .catch((conflictMessage) => {
                            this.employeeListService.currentEmployee = null;

                            if (conflictMessage) {
                                this.busyService.stop();
                                this.modalService
                                    .alert(conflictMessage, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                            }
                        })
                        .finally(() => {
                            this.accordion.toggle(newIndex);
                        });
                } else {
                    this.accordion.toggle(newIndex);
                }
            }
        }

        /**
         * Navigate forward from employees to summary tab
         * @param {number} newIndex - new accordion tab index
         * */
        goForwardFromEmployees(newIndex: number): void {
            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WalkInManagerModal, Model.VerbEnum.ContinueFromEmployeesClicked, null, this.item.appointmentId));
            this.accordion.toggle(newIndex);
        }

        /**
         * Get service categories available to walkin booking
         * */
        getServiceCategoryList(): void {
            angular.element('meevo-type-ahead[name="service"]')[0].focus();
            this.busyService.start();
            this.serviceCategoryListService.fetchCategoryList()
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * Select category from categories list. Make request for services in it.
         * */
        setCurrentCategory(category: ServiceCategory): void {
            this.serviceCategoryListService.currentCategory = category;

            if (category === null) {
                return;
            }

            this.busyService.start();
            this.serviceCategoryListService.fetchServicesList(category.id)
                .finally(() => {
                    this.busyService.stop();
                });
        }

        checkForAddons(serviceId: string): ng.IPromise<void> {
            let deferred = this.$q.defer<void>();
            this.restServer.getAppointmentServiceTemplateWithAddOns(
                null,
                serviceId,
                this.item.selectedClient ? this.item.selectedClient.id : null,
                null,
                null,
                (response: any) => {
                    if (response && response.hasServiceAddOn) {
                        const options: Meevo.Components.Modal.IModalOptions = {
                            templateUrl: 'app/plugins/AppointmentBook/views/serviceAddOns.html',
                            controller: 'meevo.plugins.appointmentBook.ServiceAddOnsController',
                            bindToController: true,
                            locals: {
                                serviceId: serviceId,
                                employeeId: null,
                                currentServiceAddOns: this.currentService.addOns,
                                finalState: null,
                                transitionState: null,
                                isReadOnly: false,
                                isFromWalkIn: true,
                                clientId: null,
                                equipmentValidator: null,
                                yieldManagementDateTime: undefined,
                                applyProductUsage: false,
                                appointmentServiceId: undefined
                            },
                            controllerAs: 'vm',
                            multiple: true
                        };
                        this.modalService.showCustom(options).then((response) => {
                            if (response.action === 'save') {
                                this.serviceCategoryListService.currentAddOns = response.data;
                            }
                            deferred.resolve();
                        });
                    } else {
                        deferred.resolve();
                    }
                }
            );

            return deferred.promise;
        }

        /**
         * Select service from list of service tiles, proceed to employee tab
         * */
        setCurrentService(service: IService): void {
            if (this.serviceCategoryListService.hasInSelected(service.id)) {
                this.modalService.alert('MESSAGE_ALREADY_SELECTED_SERVICE', Meevo.Components.Modal.ModalTranslationModes.Translate, true);

                return;
            }

            this.serviceCategoryListService.currentService = service;
            this.checkForAddons(service.id).finally(() => this.goForward())
        }

        serviceTypeaheadCallback(): void {
            if (this.currentService.service) {
                if (this.serviceCategoryListService.hasInSelected(this.currentService.service.id)) {
                    this.modalService.alert('MESSAGE_ALREADY_SELECTED_SERVICE', Meevo.Components.Modal.ModalTranslationModes.Translate, true);
                    this.serviceCategoryListService.currentService = null;

                    return;
                }

                this.checkForAddons(this.currentService.service.id)
                    .finally(() => this.goForward());
            }
        }

        setEmployeePreference(preference: EmployeeGenderSearchEnum): void {
            this.employeeListService.currentEmployeePreference = preference;
            this.employeeListService.currentEmployee = null;

            if (preference === EmployeeGenderSearchEnum.SpecificEmployee) {
                this.item.employeeGenderSearchEnum = EmployeeGenderSearchEnum.SpecificEmployee;
                this.specificEmployeeVisible = true;
                this.employeeListService.fetchEmployees(this.settingsService.settings.showOnlyClockedInEmployees);

                return; // go to specific employee (this.specificEmployeeVisible)
            }

            this.scan().then(() => {
                switch (this.currentService.employeePreference) {
                    case EmployeeGenderSearchEnum.AnyMale:
                        this.employeeNickName = 'Male Only Employee';
                        break;
                    case EmployeeGenderSearchEnum.AnyFemale:
                        this.employeeNickName = 'Female Only Employee';
                        break;
                    case EmployeeGenderSearchEnum.AnyEmployee:
                        this.employeeNickName = 'First Available Employee';
                        break;
                }
            });
        }

        setEmployee(employee: Employee): void {
            this.employeeListService.currentEmployee = employee;
            this.scan().then(() => {
                this.employeeNickName = this.currentService.employee.nickName ||
                    this.currentService.employee.firstName + ' ' + this.currentService.employee.lastName;
            });
        }

        employeeTypeaheadCallback(): void {
            this.employeeListService.currentEmployeePreference = EmployeeGenderSearchEnum.SpecificEmployee;
            this.item.employeeGenderSearchEnum = EmployeeGenderSearchEnum.SpecificEmployee;
            this.scan().then(() => {
                this.employeeNickName = this.currentService.employee.nickName ||
                    this.currentService.employee.firstName + ' ' + this.currentService.employee.lastName;
            });
        }

        scan(): ng.IPromise<IServiceOpening[]> {
            let deferred = this.$q.defer<IServiceOpening[]>();

            let nickName = this.currentService.employee ? this.currentService.employee.nickName : null;
            let id = this.currentService.employee ? this.currentService.employee.id : null;
            let scanServices = this.scanForOpeningsService.prepareServicesForScan([...this.serviceCategoryListService.selectedServices, this.currentService], this.item.selectedClient.id);

            this.busyService.start();

            this.scanForOpeningsService.scan(scanServices, nickName, id, this.item.id)
                .then((serviceOpenings: IServiceOpening[]) => {
                    this.serviceOpening = serviceOpenings[0];
                    serviceOpenings.map((opening) => {
                        opening.waitTime = Math.max(0, opening.waitTime);
                    });
                    this.busyService.stop();
                    deferred.resolve(serviceOpenings);
                })
                .catch((conflictMessage) => {
                    this.busyService.stop();
                    this.showScanError(conflictMessage);
                    deferred.reject();
                });

            return deferred.promise;
        }

        /**
         * Execute on every pane change. Manage current state
         * */
        expandCallback(index: number, id: string): void {
            if (this.currentPane.index !== index) {
                this.stateFactory[id].apply();
            }
            this.currentPane.id = id;
            this.currentPane.index = index;
        }

        /**
         * Close modal window
         * */
        public closeModal(): void {
            this.serviceCategoryListService.clear();
            this.serviceCategoryListService.clearSelectedService();
            this.employeeListService.clear();
            this.mdDialog.hide();
        }

        prepareToAdd(serviceOpenings: IServiceOpening[], isEdit: boolean = false): IWalkinAppointmentSave {
            let services: Meevo.Model.IWalkinAppointmentService[] = [
                ...this.serviceCategoryListService.selectedServices,
                this.currentService
            ].map((service: IWLSelectedService) => {
                let serviceOpening = _.find(serviceOpenings, (opening) => opening.serviceId.toString() === service.service.id);

                return {
                    id: isEdit ? this.item.id : null,
                    entityVersion: isEdit ? this.item.entityVersion : null,
                    serviceId: serviceOpening.serviceId,
                    employeeId: serviceOpening.employeeId,
                    startDateTime: serviceOpening.startTime,
                    endDateTime: serviceOpening.endTime,
                    employeeGenderSearchEnum: service.employeePreference,
                    nonRequest: service.employeePreference === EmployeeGenderSearchEnum.SpecificEmployee ? true : serviceOpening.nonRequest,
                    serviceAddOns: service.addOns.map((addOn: any) => ({
                        addOnServiceId: addOn.addOnServiceId,
                        appointmentServiceId: serviceOpening.serviceId,
                    }))
                };
            });

            return {
                clientId: serviceOpenings[0].clientId,
                note: this.item.note,
                suppressWarnings: true, // now suppressing all warnings - JR 2/12/19
                bookingMethod: Meevo.Model.BookingMethodEnum.WalkinKiosk,
                isSMSEnabled: this.item.isSMSEnabled,
                statusEnum: this.item.waitInWaitingArea ? WalkInStatusEnum.WaitingAndPresent : WalkInStatusEnum.WaitingButNotPresent,
                moveToTop: this.item.moveToTop,
                services: services
            };
        }

        addToWaitlist = () => {
            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WalkInManagerModal, Model.VerbEnum.AddToWaitListClicked, null, this.item.appointmentId));

            this.scan()
                .then((serviceOpenings: IServiceOpening[]) => {
                    this.busyService.start();
                    if (this.windowType === WalkInWizardTypeEnum.Edit) {
                        let uri = `/${this.appSettings.API_ROOT}/WalkinAppointment/${this.item.id}`;

                        this.dataService.customMethodData(uri, 'PUT', this.prepareToAdd(serviceOpenings, true))
                            .then((response) => {
                                if (response.status === 412) {
                                    // conflicted status. go to the very beginning with fresh data
                                    this.startOver();
                                } else {
                                    this.addToFinishStep(response);
                                }
                            }, (error) => {
                                console.log(error);
                            })
                            .finally(() => {
                                this.busyService.stop();
                            });
                    } else {
                        this.dataService.add('walkinAppointment', this.prepareToAdd(serviceOpenings))
                            .then((response) => {
                                this.addToFinishStep(response);
                            }, (error) => {
                                console.log(error);
                            })
                            .finally(() => {
                                this.busyService.stop();
                            });
                    }
                    this.suppressWarnings = false;
                })
                .catch(() => {
                    this.suppressWarnings = false;
                });
        }

        addToFinishStep(response) {
            if (response.isWarning) {
                let warningMessage = "";

                for (let warning of response.responseStatus.errors) {
                    warningMessage += warning.message + " ";
                }
                warningMessage += " Do you want to continue?";

                this.modalService.confirm(warningMessage)
                    .then((res) => {
                        if (res) {
                            this.suppressWarnings = true;
                            this.addToWaitlist();
                        }
                    });
            } else {
                this.closeModal();
            }
        }

        triggerMoveToTop(): void {
            this.modalService.confirmHandler('You are about to move this request to the top of the list. Do you wish to continue?')
                .then((result: boolean) => {
                    if (result) {
                        this.busyService.start();
                        this.dataService.patch('walkinAppointment', {
                            model: {
                                entityVersion: this.item.entityVersion,
                                moveToTop: this.item.moveToTop
                            }
                        }, this.item.id)
                            .then((response) => {
                                if (response.hasOwnProperty('responseStatus') &&
                                    response.responseStatus.hasOwnProperty('errorCode') &&
                                    response.responseStatus.errorCode === 'PreconditionFailed') {
                                    this.startOver();
                                } else {
                                    this.busyService.stop();
                                    this.item.entityVersion = response.entityVersion;
                                    this.closeModal();
                                }
                            })
                    } else {
                        this.item.moveToTop = false;
                    }
                });
        }

        focusClientNameInput(): void {
            const {
                requireNewClientEmail,
                requireNewClientPhoneNumber
            } = BusinessInfoDataService.businessInfoPreferences.clientsSettings;
            this.newClientEmailRequired = requireNewClientEmail;
            this.newClientPhoneRequired = requireNewClientPhoneNumber;

            this.newClientFormVisible = true;
            setTimeout(() => {
                angular.element('input[name="firstName"]')[0].focus();
            }, 0);
        }

        clientEntryChanged(): void {
            this.newClientFormVisible = (this.clientEntryType == 0);
            this.toggleNewClient();
        }

        public addNewService(): void {
            this.serviceCategoryListService.addCurrentToSelected(this.currentService.employee, this.currentService.employeePreference);
            this.serviceCategoryListService.clear();
            this.employeeListService.clear();
            this.employeeNickName = null;
            this.specificEmployeeVisible = false;
            this.accordion.toggle(1);
        }

        public deleteServiceFromSelected(serviceId: string): void {
            this.serviceCategoryListService.deleteFromSelected(serviceId);
        }

        private showScanError(conflictMessage?: string): void {
            if (typeof conflictMessage === 'undefined') {
                let message = 'MESSAGE_FULLY_BOOKED';
                switch (this.currentService.employeePreference) {
                    case EmployeeGenderSearchEnum.SpecificEmployee:
                        message = 'MESSAGE_EMPLOYEE_FULLY_BOOKED';
                        break;
                    case EmployeeGenderSearchEnum.AnyEmployee:
                        message = 'MESSAGE_FULLY_BOOKED';
                        break;
                    case EmployeeGenderSearchEnum.AnyFemale:
                    case EmployeeGenderSearchEnum.AnyMale:
                        message = 'MESSAGE_SELECTION_FULLY_BOOKED';
                        break;
                }
                this.modalService.alert(message, Meevo.Components.Modal.ModalTranslationModes.Translate, true);
            } else {
                this.modalService.alert(conflictMessage, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate, true);
            }
        }
    }

    angular.module('meevo.plugins.walkinManager')
        .controller('meevo.plugins.walkinManager.addToWaitlist.WalkinManagerModalController', WalkinManagerModalController);
}
